// API Configuration
// Uses environment variables with REACT_APP_ prefix for React apps
const getApiBaseUrl = () => {
  // Check if we have a custom API URL set
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  
  // Default to production URL if NODE_ENV is production
  if (process.env.NODE_ENV === 'production') {
    return 'https://dyn.ionet.de';
  }
  
  // Default to localhost for development
  return 'http://localhost:3001'; // Adjust port if your local server uses a different port
};

export const API_BASE_URL = getApiBaseUrl();

// Helper function to build full API URLs
export const getApiUrl = (endpoint) => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_BASE_URL}/${cleanEndpoint}`;
};

